:where(button) {
  all: unset;
  display: inline-flex;
  cursor: pointer;
}

*,
::before,
::after {
  box-sizing: border-box;
}

.error-text,
.name {
  color: inherit;
  font: inherit;
  margin: 0;
  padding: 0;
  outline: 0;
}

gx-edit:is(.gx-edit--auto-fill, .gx-edit--auto-fill:focus-within, .gx-edit--auto-fill:hover) {
  background-color: var(--gx-edit-auto-fill-background-color);
}

:host {
  display: grid;
  --chevron-color: #ccc;
}

:host(:not(.gx-disabled):hover) .button-primary,
:host(:not(.gx-disabled):focus-within) .button-primary {
  display: grid;
}
:host(:not(.gx-disabled):hover) .button-primary::before,
:host(:not(.gx-disabled):focus-within) .button-primary::before {
  content: "";
}

:host(.gx-disabled) {
  pointer-events: none;
}
:host(.gx-disabled) .accordion {
  pointer-events: all;
}

.add-new-field--level-0 {
  display: grid;
  grid-template: "name . . ." min-content "field-name type confirm cancel" 1fr "error-text . confirm cancel" min-content "sub-item sub-item confirm cancel" min-content/1fr min-content 56px 32px;
  row-gap: 8px;
}
.add-new-field--level-0 ::slotted(ch-next-data-modeling) {
  grid-area: sub-item;
}

.add-new-field--level-1 {
  display: grid;
  grid-template: "name . . ." min-content "field-name type confirm cancel" 1fr "error-text . . ." min-content/1fr min-content 56px 32px;
  row-gap: 8px;
}

.add-new-field--level-2 {
  display: grid;
  grid-template: "sub-field name . . ." min-content ". field-name type confirm cancel" 1fr ". error-text . . ." min-content/min-content 1fr min-content 56px 32px;
  row-gap: 4px;
}

.add-new-field--no-actions {
  grid-template: "sub-field name ." min-content ". field-name type" 1fr ". error-text ." min-content/min-content 1fr min-content;
}

.accordion:hover .edit-button,
.accordion:hover .delete-button,
.accordion:focus-within .edit-button,
.accordion:focus-within .delete-button {
  display: grid;
}

.sub-field {
  grid-area: sub-field;
}

.field-name {
  grid-area: field-name;
  margin-inline-end: 8px;
}

.button-confirm {
  grid-area: confirm;
  margin-inline: 16px 8px;
}

.button-cancel {
  grid-area: cancel;
}

.error-text {
  grid-area: error-text;
  display: flex;
  white-space: break-spaces;
}

.header {
  display: grid;
  grid-template: "sub-field name type edit delete" 1fr/min-content max-content 1fr min-content max-content;
  align-items: center;
  width: 100%;
  margin-inline-end: 12px;
}

.accordion::part(accordion__header) {
  column-gap: 24px;
}

.edit-mode {
  grid-template: "sub-field field-name type confirm cancel" min-content "sub-field error-text error-text confirm cancel" min-content/min-content 1fr min-content 56px 32px;
}

.name {
  grid-area: name;
}
.name-entity {
  text-decoration: underline;
}

.type {
  grid-area: type;
}

.select-wrapper {
  --chevron: url('data:image/svg+xml,<svg width="12" height="8" viewBox="0 0 12 8" xmlns="http://www.w3.org/2000/svg"><path d="M1.41 0L6 4.59L10.59 0L12 1.42L6 7.42L0 1.42L1.41 0Z"/></svg>');
  grid-area: type;
  position: relative;
}
.select-wrapper::after {
  content: "";
  display: flex;
  position: absolute;
  inset-inline-end: 0;
  inset-block-start: calc(50% - 3.75px);
  width: 12px;
  height: 7.5px;
  margin-inline: 8px 16px;
  -webkit-mask: var(--chevron) no-repeat;
  background-color: var(--chevron-color);
  pointer-events: none;
}

.select {
  display: flex;
  height: 100%;
  appearance: none;
  background-color: unset;
  cursor: pointer;
  outline: unset;
  transition-property: background-color, border-color, color;
  transition-duration: 250ms;
}

.button-new-entity {
  align-items: center;
  transition: color 250ms;
}

.optimization {
  display: contents;
}

.button-primary {
  display: none;
  align-self: center;
  height: 20px;
  padding: 2px;
}
.button-primary::before {
  display: flex;
}

.button-edit {
  grid-area: edit;
  width: 21px;
}
.button-edit::before {
  -webkit-mask: var(--edit-icon) no-repeat;
}

.button-delete {
  grid-area: delete;
  width: 18px;
  margin-inline-start: 12px;
}
.button-delete::before {
  -webkit-mask: var(--delete-icon) no-repeat;
}

.delete-mode,
.waiting-mode {
  grid-area: delete;
  display: grid;
  grid-template-columns: 1fr 24px 24px;
  align-items: center;
  column-gap: 8px;
  cursor: auto;
  animation: fade-in 250ms ease-in-out;
}

.waiting-mode {
  grid-template-columns: 24px 1fr;
}

.waiting-mode__loading {
  order: -1;
  width: 100%;
  fill: none;
  animation: rotate 1.5s linear 0.125s infinite;
}

circle {
  stroke: currentColor;
  stroke-dasharray: 1, 200;
  stroke-linecap: round;
  animation: indeterminate-loading 1.25s ease-in-out 0.125s infinite;
}

@keyframes fade-in {
  0% {
    opacity: 0;
  }
}
@keyframes rotate {
  100% {
    transform: rotate(1turn);
  }
}
@keyframes indeterminate-loading {
  50%, 60% {
    stroke-dasharray: 20, 200;
    stroke-dashoffset: -8px;
  }
  100% {
    stroke-dashoffset: -24px;
  }
}